<template>
  <div class="page">
    <img v-if="loading" class="loading-img" src="@/assets/images/loading.png"/>
    <div v-if="transCount == 0" class="v-container">
      <div class="pano-box pano-main" :class="{compare:isSplitScreen,mobile:isMobile}">
        <div id="pano" style="width: 100%; height: 100%"></div>
        <div v-if="groupList.length && isSplitScreen" class="time-line time-line-left">
          <div class="active">
            <span>{{ groupList.find(item => item.id == activeGroupId).remarkTime }}</span> <i
              class="iconfont icon-arrow-bottom"></i>
          </div>
          <div class="lists">
            <div class="box">
              <div class="item" v-for="item in groupList"
                   :class="{ active: item.id == activeGroupId,disabled : item.id == activeGroupIdCompare}"
                   :key="item.id" @click="changeGroup(item.id)">{{ item.remarkTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isSplitScreen" class="pano-box pano-compare" :class="{mobile: isMobile}">
        <div id="panoCompare" style="width: 100%; height: 100%"></div>
        <div v-if="groupList.length && activeGroupIdCompare" class="time-line time-line-right">
          <div class="active">
            <span>{{ groupList.find(item => item.id == activeGroupIdCompare).remarkTime }}</span> <i
              class="iconfont icon-arrow-bottom"></i>
          </div>
          <div class="lists">
            <div class="box">
              <div class="item" v-for="item in groupList"
                   :class="{ active: item.id == activeGroupIdCompare,disabled : item.id == activeGroupId}"
                   :key="item.id" @click="changeGroupCompare(item.id)">{{ item.remarkTime }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <fix-side/>
      <fix-compass/>
      <spot-vr-iframe v-if="isShowVrIframe" :src="vrIframeSrc" :show.sync="isShowVrIframe"/>
      <spot-video-dialog v-if="isShowVideo" :src="videoSrc" :show.sync="isShowVideo"/>
      <works-scene-bar ref="worksSceneBar"/>
    </div>
    <div v-if="transCount > 0" class="trans-loading">作品转码中，请稍后刷新重试...</div>
    <person-intro v-if="isSHowPersonIntro" :show.sync="isSHowPersonIntro" :row="spotRow"/>
    <spot-text-intro v-if="isShowSpotTextIntro" :show.sync="isShowSpotTextIntro" :row="spotRow"/>
    <el-dialog :visible="isShowViewPic" :width="isMobile ?'80%':'600px'" title="图片查看" @close="isShowViewPic =false">
      <img style="display:block;width:100%;" :src="imageSrc">
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState, mapActions} from "vuex";
import weixin from "@/assets/js/wx";
import build from "./build";
import configPage from "@/assets/js/configPage";
import spotVrIframe from "@/pages/components/spot-vr-iframe";
import spotVideoDialog from "./components/spot-video-dialog";
import worksSceneBar from "./components/works-scene-bar";
import fixSide from "./components/fix-side";
import fixCompass from "./components/fix-compass";
import personIntro from "./components/person-intro";
import spotTextIntro from "./components/sport-text-intro";


export default {
  components: {
    spotVideoDialog,
    spotVrIframe,
    worksSceneBar,
    fixSide,
    fixCompass,
    personIntro,
    spotTextIntro
  },

  data() {
    return {
      krpCompare: null,
      loading: true,
      worksId: this.$route.query.id,
      isShowVrIframe: false,
      vrIframeSrc: "",
      isShowVideo: false, //播放视频
      videoSrc: "", //视频链接
      imageSrc: "", //图片链接
      sceneDataListActive: [],
      transCount: -1,
      isSHowPersonIntro: false,
      isShowSpotTextIntro: false,
      spotRow: null,
      isShowViewPic: false,
    };
  },

  computed: {
    ...mapState("preview", [
      "isFromIndexMap",
      "krp",
      "materialId",
      "sceneList",
      "sceneListCompare",
      "groupList",
      "activeGroupId",
      "activeGroupIdCompare",
      "isSplitScreen",
      "sceneDataCompare",
      "worksDetail"
    ]),

    sceneData() {
      let sceneList = this.worksDetail.sceneList;
      return Array.isArray(sceneList)
          ? sceneList.find((item) => this.materialId == item.id)
          : {};
    },
  },

  watch: {
    async isSplitScreen() {
      await this.$nextTick();
      if (this.isSplitScreen) {
        this.loadRightPano()
      }
    }
  },

  provide() {
    return {
      openVr: this.openVr,
    };
  },

  async created() {
    window.krpjs.hideLoading = () => {
      this.loading = false;
    };
    window.krpjs.handleClickHotspot = this.handleClickHotspot;
    await this.getGroupList();
    this.getWorksDetail();
    this.upViews();
  },

  methods: {
    ...mapMutations("preview", {
      mutationUpdateKrp: "UPDATE_KRP",
      mutationUpdateMaterialId: "UPDATE_MATERIAL_ID",
      mutationUpdateSceneList: "UPDATE_SCENE_LIST",
      mutationUpdateActiveGroupIdCompare: "UPDATE_ACTIVE_GROUP_ID_COMPARE",
      mutationUpdateSceneListCompare: "UPDATE_SCENE_LIST_COMPARE",
      mutationUpdateSceneDataCompare: "UPDATE_SCENE_DATA_COMPARE",
    }),
    ...mapActions("preview", {
      activeGetWorksDetail: "getWorksDetail",
      activeGetGroupList: "getGroupList"
    }),

    handleClickHotspot(id) {
      let isFromCompare = false;
      let row = this.sceneData.extra.spotList.find((item) => item.id == id);
      if (!row) {
        isFromCompare = true;
        row = this.sceneDataCompare.extra.spotList.find((item) => item.id == id);
      }

      if (row.type === 1 && row.vrType === 1 && row.url) {
        this.vrIframeSrc = row.url;
        this.isShowVrIframe = true;
        return
      }

      if (row.type == 1 && row.vrType == 2 && row.fromId) {
        let materialId = row.fromId;
        if (isFromCompare) {
          let toSceneDataFind = this.sceneListCompare.find(item => item.id == row.fromId);
          materialId = this.getToGroupMid(toSceneDataFind, this.sceneList);
        }
        this.openVr(materialId);
        return
      }

      if (row.type == 2 && (row.url || row.videoPreview)) {
        this.videoSrc = row.videoType == 1 ? row.url : row.videoPreview;
        this.isShowVideo = true;
        return
      }

      if (row.type === 3 && row.ext.spotTextIntro) {
        this.spotRow = row;
        this.isShowSpotTextIntro = true;
        return
      }

      if (row.imageType == 6) {
        this.spotRow = row;
        this.isSHowPersonIntro = true;
        return
      }

      if (row.imageType === 7) {
        this.isShowViewPic = true;
        this.imageSrc = row.imagePreview;
        return
      }
    },

    async getGroupList() {
      return await this.activeGetGroupList(this.worksId);
    },

    async getWorksDetail() {
      await this.activeGetWorksDetail({worksId: this.worksId, groupId: this.activeGroupId});
      this.transCount = this.worksDetail.transCount;
      if (this.transCount > 0) {
        this.loading = false;
        return
      }
      this.$nextTick(async () => {
        let sceneList = this.worksDetail.sceneList.filter(item => item.status == 2);
        let krp = await build.initKrpano('pano');
        this.mutationUpdateKrp(krp);
        this.mutationUpdateSceneList(sceneList);
        this.mutationUpdateMaterialId(sceneList[0].id);
        build.loadPano(krp, sceneList[0]);
        this.initPage();
      })
    },

    async upViews() {
      await this.api.works.upViews({worksId: this.worksId});
    },

    openVr(materialId) {
      let blend = 'OPENBLEND(0.5, 0.0, 0.75, 0.05, linear)'
      let sceneData = this.sceneList.find(item => item.id == materialId);
      this.mutationUpdateMaterialId(materialId);
      build.loadPano(this.krp, sceneData, null, 'KEEPIMAGE', `loadscene(scene_${materialId},null,null,${blend});`);
      if (this.isSplitScreen) {
        let toMaterialId = this.getToGroupMid(sceneData, this.sceneListCompare);
        let toSceneData = this.sceneListCompare.find(item => item.id == toMaterialId);
        build.loadPano(document.getElementById(this.krp.get('syncviewer')), toSceneData, null, 'KEEPIMAGE', `loadscene(scene_${toMaterialId},null,null,${blend});`);
        this.mutationUpdateSceneDataCompare(toSceneData);
      }
    },

    async initPage() {
      let ui = await configPage.getUi(this.$route.query.subjectId);
      document.title = ui.title;
      document.querySelector('link[rel="icon"]').href = ui.ico;
      await weixin.setWxConfig({title: ui.title, desc: ""});
      weixin.setWxConfig({
        title: this.worksDetail.name,
        desc: ui.title,
        imgUrl: ui.mLogo,
      });
    },

    async loadRightPano(groupId) {
      // if (this.krpCompare) {
      //   this.krpCompare.unload()
      // }
      this.krpCompare = this.krpCompare? this.krpCompare : (await build.initKrpano('panoCompare'));
      let groupIndex = this.groupList.findIndex(item => item.id == this.activeGroupId);
      let toGroupId = groupId || (this.groupList[groupIndex + 1] ? this.groupList[groupIndex + 1].id : this.groupList[groupIndex - 1].id);
      let sceneData = this.sceneList.find(item => item.id == this.materialId);
      let toWorksDetail = await this.activeGetWorksDetail({worksId: this.worksId, groupId: toGroupId, noUpdate: true});
      let toSceneList = toWorksDetail.sceneList.filter(item => item.status == 2);
      let toMaterialId = this.getToGroupMid(sceneData, toSceneList);
      let toSceneData = toSceneList.find(item => item.id == toMaterialId);
      this.mutationUpdateActiveGroupIdCompare(toGroupId);
      this.mutationUpdateSceneListCompare(toSceneList);
      this.mutationUpdateSceneDataCompare(toSceneData);
      let flags = 'KEEPIMAGE';
      let loaddone = `loadscene(scene_${toSceneData.id},null,MERGE,OPENBLEND(0.5, 0.0, 0.75, 0.05, linear));`;
      build.loadPano(this.krpCompare, toSceneData,null, flags, loaddone);
    },


    changeGroup(groupId) {
      if (groupId == this.activeGroupIdCompare) {
        return
      }
      this.$refs.worksSceneBar.doChangeGroup(groupId);
    },

    changeGroupCompare(groupId) {
      if (groupId == this.activeGroupId) {
        return
      }
      this.loadRightPano(groupId);
    },

    //获取指定分组-场景id
    getToGroupMid(sceneData, toSceneList) {
      let fromRelativeMid = sceneData.topId || sceneData.id;
      let toScene = toSceneList.find((item) => fromRelativeMid == (item.topId || item.id));
      return toScene ? toScene.id : toSceneList[0].id;
    },
  },
};
</script>

<style scoped>
.page {
  background: #000;
  width: 100%;
  height: 100%;
}

.v-container {
  background: #000;
  position: relative;
}

.loading-img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: 56px;
  height: 24px;
}

.back-vr {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #43897b;
  color: #fecf7c;
  padding: 0 15px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  height: 30px;
  display: flex;
  align-items: center;
}

.back-vr i {
  font-weight: bold;
  margin-right: 5px;
  color: #fecf7c;
}

.trans-loading {
  width: 100vw;
  height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.pano-box {
  width: 100%;
  height: 100%;
  position: absolute;
}

.pano-main.compare {
  width: 50%;
}

.pano-main.compare.mobile {
  width: 100%;
  height: 50%;
}

.pano-compare {
  position: absolute;
  left: 50%;
  top: 0;
  width: 50%;
}

.pano-compare.mobile {
  left: 0;
  top: 50%;
  width: 100%;
  height: 50%;
}

.time-line {
  position: absolute;
  width: 120px;
  color: #fff;
  top: 10px;
  left: 10px;
  font-size: 12px;
}

.time-line > .active {
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.6);
}

.time-line > .active .iconfont {
  font-size: 12px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-8px, -50%) scale(0.7);
}

.time-line .lists {
  position: absolute;
  top: 100%;
  width: 100%;
  display: none;
  padding-top: 4px;
}

.time-line .lists .box {
  background: rgba(0, 0, 0, 0.6);
  padding: 0 10px;
  border-radius: 4px;
}

.time-line:hover .lists {
  display: block;
}

.time-line .lists .item {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom: 1px solid #fff;
  position: relative;
}

.time-line .lists .item.active {
  color: #409eff;
  cursor: not-allowed;
}

.time-line .lists .item.disabled {
  color: #7a7a7a;
  cursor: not-allowed;
}

.time-line .lists .item:last-child {
  border-bottom: 0;
}

.time-line .lists .item .iconfont {
  position: absolute;
  font-size: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  right: 0;
}

.time-line .lists .item.active .iconfont {
  color: #409eff;
}

</style>
